import { ThunkDispatch } from 'redux-thunk'
import { connect } from 'react-redux'
import { AnyAction } from 'redux'

import { DrugModelAccess } from './DrugModelAccess'
import { IDisplayDispatchProps, IStateProps } from './types'
import { IState } from '../../../../store/types'
import { fetchDrugs } from '../../../../store/drugs/actions'

const mapStateToProps = (state: IState): IStateProps => {
  return {
    drugs: state.drugs
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): IDisplayDispatchProps => {
  return {
    fetchDrugs: () => {
      return dispatch(fetchDrugs())
    }
  }
}

const DrugModelAccessContainer = connect(mapStateToProps, mapDispatchToProps)(DrugModelAccess)

export { DrugModelAccessContainer }
